/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function ProfessionField (props: FormTextFieldProps) {
  const { name = 'profession', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'profession',
        defaultMessage: 'Profession'
      })}
      name={name}
      parser={upperFirst}
      {...others}
    />
  )
}

export default ProfessionField
